import { Trans, useTranslation } from "react-i18next";
import { cn } from "../../../../utils/classnames";
import { createTypographyHelper } from "../../../../utils/typography";

const ExecutiveTransferImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/services/executive-transfer-card.png";
const SeamlessEventImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/services/executive-transfer-seamless-event.png";
export const ExecutiveTransfer = () => {
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);
  return (
    <div className="tw:lg:px-[82px]">
      <div className="tw:px-5 tw:lg:px-0 tw:mt-7 tw:lg:mt-[54px]">
        <div className="tw:flex tw:flex-col tw:lg:flex-row tw:rounded-[10px] tw:overflow-hidden">
          <img
            src={ExecutiveTransferImage}
            alt="Airport Transfer Card"
            className="tw:w-full tw:h-[300px] tw:lg:h-[260px] tw:lg:min-w-[452px] tw:object-cover tw:rounded-t-[10px] tw:lg:rounded-none tw:flex-1"
          />
          <div className="tw:bg-[#F9F9F9]">
            <div className="tw:px-[25px] tw:lg:px-[48px] tw:pt-8 tw:lg:pt-[46px] tw:pb-7 tw:lg:pb-[46px] tw:space-y-[10px]">
              <div className="tw:pb-4 tw:border-b tw:border-b-[#F1F1F1] tw:mb-4">
                <div className="tw:font-semibold tw:text-[#282828] tw:tracking-[3px] tw:text-[8px] tw:font-hanken-grotesk tw:uppercase">
                  {t(`Service.ExecutiveTransfer.SubTitle`)}
                </div>
                <div className="tw:text-[#282828] tw:font-libre-caslon-display tw:text-[26px] tw:lg:text-[45px] tw:leading-[35px] tw:lg:leading-[58px]">
                  {t(`Service.ExecutiveTransfer.Title`)}
                </div>
              </div>
              <div
                className={cn(
                  "tw:text-[#4E4E4E] tw:font-hanken-grotesk",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t(`Service.ExecutiveTransfer.Description`)}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tw:mt-8 tw:lg:mt-[54px] tw:px-5 tw:lg:px-0 tw:font-libre-caslon-display tw:leading-[23px] tw:lg:leading-[26px] tw:lg:text-[22px] tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1]">
        <div>{t(`Service.ExecutiveTransfer.Quote`)}</div>
      </div>

      <div className="tw:px-5 tw:lg:px-0 tw:mt-8 tw:lg:mt-[54px] tw:font-hanken-grotesk tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1] tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row tw:lg:gap-x-[69px]">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[200px] tw:lg:w-[200px]">
          <div>{t(`Service.ExecutiveTransfer.TailoredTransfer.Title`)}</div>
        </div>
        <div>
          <div>
            <div
              className={cn(
                "tw:mt-5 tw:lg:mt-0",
                getTypographyClass(13),
                getTypographyClass(14, "lg")
              )}
            >
              <div>
                <Trans
                  i18nKey={`Service.ExecutiveTransfer.TailoredTransfer.Description`}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tw:px-5 tw:lg:px-0 tw:mt-8 tw:lg:mt-[54px] tw:font-hanken-grotesk tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1] tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row tw:lg:gap-x-[69px]">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[200px] tw:lg:w-[200px]">
          {t("Service.ExecutiveTransfer.SeamlessEvent.Title")}
        </div>
        <div className="tw:flex tw:flex-col tw:lg:flex-row tw:gap-5 tw:lg:gap-[45px]">
          <div
            className={cn(
              "tw:mt-5 tw:lg:mt-0",
              getTypographyClass(13),
              getTypographyClass(14, "lg")
            )}
          >
            <Trans
              i18nKey="Service.ExecutiveTransfer.SeamlessEvent.Description"
              components={{
                strong: <strong></strong>,
              }}
            />
          </div>
          <img
            src={SeamlessEventImage}
            alt="Seamless Event & Meeting Transportation"
            className="tw:h-[174px] tw:lg:h-[200px] tw:lg:min-w-[450px] tw:rounded-[5px]"
          />
        </div>
      </div>

      <div className="tw:px-5 tw:lg:px-0 tw:mt-8 tw:lg:mt-[54px] tw:font-hanken-grotesk tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1] tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row tw:lg:gap-x-[69px]">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[200px] tw:lg:w-[200px]">
          {t("Service.ExecutiveTransfer.GolfEquipment.Title")}
        </div>
        <div
          className={cn(
            "tw:mt-5 tw:lg:mt-0",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          <Trans
            i18nKey="Service.ExecutiveTransfer.GolfEquipment.Description"
            components={{
              strong: <strong></strong>,
            }}
          />
        </div>
      </div>
    </div>
  );
};
